// App button = Aurora <Button>. Our variant names map to Aurora variant × appearance.
import { Button as AuroraButton, type ButtonProps as AuroraButtonProps } from '@aurora-reactkit/components/button';

type Variant = 'primary' | 'secondary' | 'ghost' | 'critical';
const MAP: Record<Variant, Pick<AuroraButtonProps, 'variant' | 'appearance'>> = {
  primary: { variant: 'accent', appearance: 'fill' },
  secondary: { variant: 'accent', appearance: 'outline' },
  ghost: { variant: 'accent', appearance: 'transparent' },
  critical: { variant: 'critical', appearance: 'fill' },
};

type Props = Omit<AuroraButtonProps, 'variant' | 'appearance' | 'size'> & {
  variant?: Variant;
  size?: 'md' | 'sm';
  block?: boolean;
};

export function Button({ variant = 'primary', size = 'md', block, className, ...rest }: Props) {
  return <AuroraButton {...MAP[variant]} size={size} className={[block && 'w-full', className].filter(Boolean).join(' ')} {...rest} />;
}
